export const recommendationsByLocale = {
  '.com': {
    bras: {
      defaultProductCategoryIds: [],
      fpls: 13602,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 16257,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 16257,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 16257,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 16257,
    },
  },
  '.co.uk': {
    bras: {
      defaultProductCategoryIds: [1124],
      fpls: null,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 12863,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 12863,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 12863,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 12863,
    },
  },
  '.eu': {
    bras: {
      defaultProductCategoryIds: [1124],
      fpls: null,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 12849,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 12849,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 12849,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 12849,
    },
  },
  '.de': {
    bras: {
      defaultProductCategoryIds: [1124],
      fpls: null,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 12835,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 12835,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 12835,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 12835,
    },
  },
  '.es': {
    bras: {
      defaultProductCategoryIds: [1124],
      fpls: null,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 12842,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 12842,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 12842,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 12842,
    },
  },
  '.fr': {
    bras: {
      defaultProductCategoryIds: [1124],
      fpls: null,
    },
    undies: {
      defaultProductCategoryIds: [1125],
      fpls: null,
    },
    lingerie: {
      defaultProductCategoryIds: [],
      fpls: 12856,
    },
    sleep: {
      defaultProductCategoryIds: [],
      fpls: 12856,
    },
    accessories: {
      defaultProductCategoryIds: [],
      fpls: 12856,
    },
    default: {
      defaultProductCategoryIds: [],
      fpls: 12856,
    },
  },
};
